import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import type { CertificateRequest } from "../user/getCertificateRequests";
import { getApprovalConfig } from "@/requests/certificates/employmentCertificate/views/config/certificateApprovals";


export const getSupervisorPendingRequests = async (supervisorUserId: string) => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;
        const workerProfileCollectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID;

        if (!databaseId || !collectionId || !workerProfileCollectionId) {
            throw new Error("Missing environment variables");
        }

        // PASO 1: Obtener todos los trabajadores que este supervisor supervisa
        const workersResponse = await databases.listDocuments(
            databaseId,
            workerProfileCollectionId,
            [
                Query.equal('idSupervisor', supervisorUserId),
                Query.limit(100)
            ]
        );

        const supervisedUserIds = workersResponse.documents.map(doc => doc.userId);

        if (supervisedUserIds.length === 0) {
            return {
                success: true,
                data: []
            };
        }

        // PASO 2: Obtener todas las solicitudes de esos trabajadores
        const response = await databases.listDocuments(
            databaseId,
            collectionId,
            [
                Query.equal('userId', supervisedUserIds),
                Query.orderDesc('requestDate')
            ]
        );

        // PASO 3: Filtrar solo los certificados que requieren aprobación de supervisor
        // y donde el supervisor aún no ha actuado
        const filteredRequests = (response.documents as unknown as CertificateRequest[]).filter(request => {
            const config = getApprovalConfig(request.type);
            
            const requiresSupervisor = config.requiredApprovals.includes('supervisor');
            const supervisorPending = request.statusBySupervisor === 'pending' || 'approved';
            
            return requiresSupervisor && supervisorPending;
        });

        return {
            success: true,
            data: filteredRequests
        };

    } catch (error) {
        console.error("Error fetching supervisor pending requests:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error desconocido",
            data: []
        };
    }
};